import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMitigationCosts = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .654765,
			d: "M30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0Z",
			fill: "#CDE2FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.2451 42.4902C37.0079 42.4902 42.4902 37.0079 42.4902 30.2451C42.4902 23.4823 37.0079 18 30.2451 18C23.4823 18 18 23.4823 18 30.2451C18 37.0079 23.4823 42.4902 30.2451 42.4902Z",
			stroke: "#032478",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.4619 33.0281C27.4619 34.5643 28.7087 35.8111 30.2449 35.8111C31.7811 35.8111 33.0279 34.5643 33.0279 33.0281C33.0279 31.4919 31.7811 30.2451 30.2449 30.2451C28.7087 30.2451 27.4619 28.9983 27.4619 27.4621C27.4619 25.9259 28.7087 24.6791 30.2449 24.6791C31.7811 24.6791 33.0279 25.9259 33.0279 27.4621",
			stroke: "#032478",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.2451 23.0093V37.4808",
			stroke: "#032478",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMitigationCosts;
